import { createAction } from '@reduxjs/toolkit'

// export const setLoggedUserInfo = createAction<LoggedUser | null>('user/setLoggedUserInfo')
// export const setAccessToken = createAction<string>('user/setAccessToken')
// export const logoutUser = createAction<void>('user/logoutUser')
export const setUserPreferredFontSize = createAction<number>('user/setUserPreferredFontSize')
